import {Badge, Button, type ButtonProps, NumberFormatter, Text, useComputedColorScheme} from '@mantine/core'
import {useCallback, useState} from 'react'
import type {Subscription} from '@package/shared'
import {useStripe} from '../../../providers/stripe/useStripe.ts'

type Props = ButtonProps & {price: Subscription['prices'][number]}

export const SubscribeButton = ({price, disabled: containerDisabled, ...rest}: Props) => {
  const colorScheme = useComputedColorScheme()
  const {subscribe} = useStripe()
  const [forwarding, setForwarding] = useState<boolean>(false)

  const handleClick = useCallback(async () => {
    setForwarding(true)
    try {
      const response = await subscribe({
        priceId: price.id,
        successUrl: location.href,
        cancelUrl: location.href,
      })
      const link = response?.link
      if (!link) return
      window.open(link, '_blank')
    } finally {
      setForwarding(false)
    }
  }, [price.id, subscribe])

  const textColor = colorScheme === 'dark' ? 'white' : 'black'

  const disabled = containerDisabled

  return (
    <Button {...rest} onClick={handleClick} loading={forwarding} disabled={disabled}>
      <Text size={'lg'} c={textColor}>
        <NumberFormatter prefix={`€ `} value={price.price} thousandSeparator />
      </Text>
      <Text p={2} c={textColor}>
        /
      </Text>
      <Text style={{paddingLeft: 0, opacity: 0.8}} size={'sm'} c={textColor}>
        {price.interval}
      </Text>

      {price.trialDays > 0 && (
        <Badge
          variant={'outline'}
          size={'sm'}
          color={'green'}
          ml={5}
          style={{pointerEvents: 'none', opacity: disabled ? 0.5 : undefined}}
        >
          trial
        </Badge>
      )}
    </Button>
  )
}
